import { useContext } from 'react';
import { SearchContext } from './SearchProvider';

export default function useFilterContext() {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error('useSearchContext must be used within a SearchProvider');
  }
  return context;
}
